import "../../styles/menu.scss";
import React, { useEffect } from "react";
import { MobileCrossActivity } from "../../segmentedComponents/CrossActivity";
import { TrackingInfo } from "../tracking/TrackingInfoMenu";
import { ClientProviderEnum } from "../../constants";
import SearchMenuSection from "../Menu/Search/SearchMenuSection";
import TopMenuSection from "../Menu/TopMenuSection/TopMenuSection";
import HomeSection from "../../segmentedComponents/HomeSection";
import CategoriesMobile from "../Menu/Categories/CategoriesMobile";
import RegulationLogosSection from "../../segmentedComponents/RegulationLogosSection";
import SecondaryMenu from "../../segmentedComponents/SecondaryMenu";
import { useSelector } from "react-redux";
import { SearchSelectors } from "../../redux/selectors";
import { BrandUtils } from "../../utils/brandUtils";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators";
import { PageContextUtils, ThemeUtils } from "../../utils";

const HamburgerMenuMobile = () => {
  const dispatch = useDispatch();
  const searchActive = useSelector(SearchSelectors.searchActive);

  const { name } = PageContextUtils.getClientProviderData();

  useEffect(() => {
    setTimeout(() => {
      dispatch(MenuActionCreators.setDrawersRendering(false));
      dispatch(MenuActionCreators.setDrawersLoaded(true));
    }, 250);
  }, [dispatch]);

  return (
    <div className={"hamburger-menu"}>
      {!searchActive && !ThemeUtils.isMrGreenTheme() && (
        <MobileCrossActivity trackingInfo={TrackingInfo} />
      )}
      {name === ClientProviderEnum.Kambi && <SearchMenuSection />}
      <div
        className={`searchAnimation${searchActive ? " animationStart" : ""}`}
      >
        {ThemeUtils.isMrGreenTheme() && (
          <React.Fragment>
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
            <TopMenuSection trackingInfo={TrackingInfo} />
          </React.Fragment>
        )}
        {!ThemeUtils.isMrGreenTheme() && (
          <React.Fragment>
            <TopMenuSection trackingInfo={TrackingInfo} />
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
          </React.Fragment>
        )}
        <HomeSection
          trackingInfo={{
            dataEvent: "UC_GENERIC_EVENT_important",
            ...TrackingInfo
          }}
        />
        {!BrandUtils.isPokerClient() && (
          <CategoriesMobile trackingInfo={TrackingInfo} />
        )}
        <RegulationLogosSection
          trackingInfo={TrackingInfo}
          showControlCenter={true}
        />
        <SecondaryMenu trackingInfo={TrackingInfo} />
      </div>
    </div>
  );
};

export default React.memo(HamburgerMenuMobile);
